import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import MetaOpenGraph from 'ecosystem-marketplace-core/components/elements/MetaOpenGraph';
import MetaTwitter from 'ecosystem-marketplace-core/components/elements/MetaTwitter'; // @ts-expect-error image

import twitterImageUrl from 'bender-url!marketplace-assets-base/img/storefront-home-twitter.jpg'; // @ts-expect-error image

import openGraphImageUrl from 'bender-url!marketplace-assets-base/img/storefront-home-og.jpeg';
import { useCanonicalUrl } from '../../../hooks/useCanonicalUrl';

function StorefrontSocialSharing({
  description,
  title
}) {
  const canonicalUrl = useCanonicalUrl();
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(MetaTwitter, {
      name: "card"
    }), /*#__PURE__*/_jsx(MetaTwitter, {
      name: "site"
    }), /*#__PURE__*/_jsx(MetaTwitter, {
      name: "image",
      content: twitterImageUrl
    }), /*#__PURE__*/_jsx(MetaOpenGraph, {
      property: "type"
    }), /*#__PURE__*/_jsx(MetaOpenGraph, {
      property: "url",
      content: canonicalUrl
    }), /*#__PURE__*/_jsx(MetaOpenGraph, {
      property: "title",
      content: title
    }), /*#__PURE__*/_jsx(MetaOpenGraph, {
      property: "description",
      content: description
    }), /*#__PURE__*/_jsx(MetaOpenGraph, {
      property: "image",
      content: openGraphImageUrl
    })]
  });
}

export default StorefrontSocialSharing;